import React, {Component} from 'react'

import Tooltip from '@material-ui/core/Tooltip'
import Button from '@material-ui/core/Button'

import AddIcon from '@material-ui/icons/Add'
import EditIcon from '@material-ui/icons/Ballot'
import DeleteIcon from '@material-ui/icons/DeleteForever'

import PaperBlock from "../../../ui/PaperBlock"

/**
 * selected
 * 
 * onAttachClick()
 * onEditClick(attachment)
 * onRemoveClick(attachment)
 */

class ControlPanel extends Component {

	constructor(props) {
		super(props)
		this.state = {
			anchorEl: null,
			appendButtonTooltipOpenState: false,
		}
	}

    render() {
        return <PaperBlock style = {{display: "flex"}}>

			<Tooltip title = "Добавить предмет"><div>
				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onAttachClick === "function") {
							this.props.onAttachClick(this.props.selected)
						}
					}}
				>
					<AddIcon />
				</Button>
			</div></Tooltip>


            <Tooltip title = "Редактировать"><div>
				<Button
                    disabled = {!this.props.selected}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onEditClick === "function") {
							this.props.onEditClick(this.props.selected)
						}
					}}
				>
					<EditIcon />
				</Button>
			</div></Tooltip>

            <Tooltip title = "Удалить"><div>
				<Button
					disabled = {!this.props.selected}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onRemoveClick === "function") {
							this.props.onRemoveClick(this.props.selected)
						}
					}}
				>
					<DeleteIcon />
				</Button>
			</div></Tooltip>

        </PaperBlock>
    }

}

export default ControlPanel